import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PageHeader } from '../components/PageHeader';
import { OfferCard } from '../components/OfferCard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function OffersPage() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        fetchOffers();
    }, []);

    const fetchOffers = async () => {
        try {
            const response = await axios.get(`${API}/offers`);
            setOffers(response.data);
        } catch (error) {
            console.error('Error fetching offers:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredOffers = offers.filter(offer => {
        if (filter === 'all') return true;
        return offer.audience === filter;
    });

    return (
        <div className="page-container" data-testid="offers-page">
            <PageHeader title="Offers" />
            
            <div className="px-4 py-4">
                <Tabs value={filter} onValueChange={setFilter} className="w-full">
                    <TabsList className="w-full h-12 rounded-full bg-primary/10 p-1">
                        <TabsTrigger 
                            value="all" 
                            className="flex-1 rounded-full data-[state=active]:bg-primary data-[state=active]:text-white h-10 text-base font-medium"
                            data-testid="filter-all"
                        >
                            All Offers
                        </TabsTrigger>
                        <TabsTrigger 
                            value="everyone" 
                            className="flex-1 rounded-full data-[state=active]:bg-primary data-[state=active]:text-white h-10 text-base font-medium"
                            data-testid="filter-everyone"
                        >
                            Everyone
                        </TabsTrigger>
                        <TabsTrigger 
                            value="members" 
                            className="flex-1 rounded-full data-[state=active]:bg-primary data-[state=active]:text-white h-10 text-base font-medium"
                            data-testid="filter-members"
                        >
                            Members
                        </TabsTrigger>
                    </TabsList>
                </Tabs>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                    </div>
                ) : (
                    <div className="space-y-4 mt-6" data-testid="offers-list">
                        {filteredOffers.length === 0 ? (
                            <div className="card-base text-center py-8">
                                <p className="text-muted-foreground">No offers available at the moment.</p>
                            </div>
                        ) : (
                            filteredOffers.map(offer => (
                                <OfferCard key={offer.id} offer={offer} />
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OffersPage;
